import { ConApartados } from '../ConApartados';
import type { PropsPantalla } from '../tipos';
import { Informes } from './Informes';
import { ListaPedidos } from './ListaPedidos';
import './pedidos.css';

/**
 * Pantalla «Entradas» (entrada `pedidos`, G778): pinta su barra Pedidos · Informes con los apartados que manda el servidor
 * (`pedidos_pedidos`, `pedidos_informes`; `nested_as: section`, G130), cada uno solo a quien tiene su permiso. El Socio,
 * con solo `entradas.informes.ver`, ve solo Informes y sin barra. Taquilla es otra entrada del menú (`taquilla`, Acceso).
 */
const APARTADOS = {
    pedidos_pedidos: ListaPedidos,
    pedidos_informes: Informes,
};

export function Pedidos(props: PropsPantalla) {
    return <ConApartados {...props} prefijo="pedidos_" seccion="Entradas" icono="ticket" apartados={APARTADOS} />;
}
